export default __webpack_public_path__ + "static/media/misc-makeupA-1920w.41fea339.avif";